<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      货运信息
      <div v-if="['服务商分销下单', 'SMB分销下单'].includes(form.contractType)" class="error-text">
        注:若要修改地址和货运信息,请重新下单或下单后修改地址。
      </div>
      <template v-if="form.specialProduct === 2 && !productList.length">
        <div v-if="['服务商分销下单', 'SMB分销下单'].includes(form.contractType)" class="error-text">
          注:此合同产品全部是战略产品，若要修改地址和运输方式可以在后续申请发货时修改，此合同直接提交即可。
        </div>
        <div v-if="!['服务商分销下单', 'SMB分销下单'].includes(form.contractType)" class="error-text">
          注:此合同产品全部是战略产品，可在此处填写地址和运输方式，系统正常计算运费差价。
        </div>
      </template>
    </div>
    <div class="rj-page-card__content">
      <div class="item">
        <span>运输方式：</span>
        <el-radio-group v-model="info.shippingType" :disabled="['SMB分销下单', '服务商分销下单'].includes(form.contractType) || form.freightContract || form.outsideFeightContract" @change="shippingTypeChange">
          <el-radio :label="0">
            陆运
          </el-radio>
          <el-radio :label="1" :disabled="isHaveBattery">
            航空
          </el-radio>
        </el-radio-group>
      </div>

      <div class="item">
        <span>承运商：</span>
        <el-select v-model="info.carrier" :disabled="['SMB分销下单', '服务商分销下单'].includes(form.contractType) || info.shippingType !== 0 || form.freightContract" placeholder="请选择" @change="carrierChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <div class="item">
        <span>运费：</span> {{ info.freight }}元
        <span>运费支付方式：</span>
        <el-radio-group v-model="info.freightPayType" :disabled="parseInt(this.info.freight) === 0 || this.info.freight === null" @change="reChange">
          <el-radio :label="0">
            现金
          </el-radio>
          <el-radio :label="1">
            返利
          </el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { freightDifference } from '@/API/index.js';
export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    contractNum: {
      type: [String, Number],
      required: true
    },
    receiptAddressId: {
      type: [String, Number],
      required: true
    },
    productList: {
      type: Array,
      default () {
        return [];
      }
    },
    moreAddress: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'form.freight': {
      immediate: true,
      handler (newVal) {
        this.info.freight = newVal;
      }
    },
    moreAddress: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.moreAddress = newVal;
      }
    }
  },
  data () {
    return {
      loading: false,
      isHaveBattery: false,
      info: {
        shippingType: 0,
        carrier: '默认物流',
        freight: 0,
        freightPayType: 0,
        freightUseRebate: null
      },
      options: [{
        label: '默认物流',
        value: '默认物流'
      }, {
        label: '顺丰',
        value: '顺丰'
      }]
    };
  },
  mounted () {
    this.$nextTick(function () {
      this.info.shippingType = this.form.shippingType || 0;
      this.info.carrier = this.form.carrier ? this.form.carrier : '默认物流';
      this.info.freight = this.form.freight;
      this.info.freightPayType = this.form.freightPayType || 0;
      this.info.freightUseRebate = this.form.freightUseRebate;
      // 通知兄弟组件产品列表计算时加页面初始化的运费
      if (this.info.freightPayType === 0) {
        this.$emit('getFreight', this.info.freight);
      } else {
        this.$emit('getFreight', 0);
      }
    });

    // this.fecthFreightDifference();
  },
  methods: {
    // AI修改：多地址场景下，运输条件变化后主动让旧的运费差价计算结果失效。
    invalidateMoreAddressFee () {
      this.$emit('invalidateMoreAddressFee');
    },
    reset () {
      this.$emit('reChange', { flag: 0 });
      this.$emit('getFreight', 0);
      if (this.moreAddress) {
        this.invalidateMoreAddressFee();
      }
      // 重置运费金额和承运商
      this.info.shippingType = 0;
      this.info.carrier = '默认物流';
      this.info.freightPayType = 0;
      this.info.freightUseRebate = null;
      this.info.freight = 0;
    },
    // 运输方式改变初始化承运商
    async shippingTypeChange () {
      // 清除产品列表的运费项和运费支付方式
      if (this.info.freightPayType !== null) {
        this.$emit('reChange', { flag: 0 });
        this.info.freightPayType = 0;
      }
      if (this.moreAddress) {
        this.invalidateMoreAddressFee();
      }
      // 重置运费金额和承运商
      this.info.carrier = '默认物流';
      this.info.freight = 0;
      this.$emit('getFreight', 0);
      // 判断运输方式如果选的是航空，重新查询运费 服务商分销也需要
      if (this.info.shippingType) {
        if (!this.moreAddress) {
          await this.fecthFreightDifference();
        }
      } else if (this.info.shippingType === 0 && this.form.contractType === '服务商分销下单') {
        if (!this.moreAddress) {
          await this.fecthFreightDifference();
        }
      }
    },
    // 承运商改变修改运费值
    async carrierChange () {
      // 清除产品列表的运费项项和运费支付方式
      if (this.info.freightPayType !== null) {
        this.$emit('reChange', { flag: 0 });
        this.info.freightPayType = 0;
      }
      if (this.moreAddress) {
        this.invalidateMoreAddressFee();
      }
      if (this.moreAddress) {
        // 多地址的时候不清空金额，进行计算
        return;
      }
      // 当前承运商如果是默认物流，运费直接赋值0元，否则就发起请求，查询运费，
      if (this.info.carrier === '默认物流' && this.form.contractType !== '服务商分销下单') {
        this.info.freight = 0;
        this.$emit('getFreight', 0);
      } else {
        await this.fecthFreightDifference();
      }
    },
    // 运费支付方式如果是现金，则在父组件中产品列表添加运费项
    reChange () {
      if (this.info.freightPayType === 0) {
        // 运费信息
        const product = {
          salesInvoiceName: '价外费用-运费',
          productName: '价外费用-运费',
          productNum: 1,
          productCode: 'NG11400105',
          unit: '个',
          productPriceSigle: this.info.freight,
          orderAmount: this.info.freight,
          beforeSplitProductPriceSigle: this.info.freight,
          pname: 0
        };
        // 通知父组件产品列表添加运费一行
        this.$emit('reChange', { flag: 1, product });
        this.$emit('getFreight', this.info.freight);
      } else {
        // 通知父组件产品列表删除运费一行
        this.$emit('reChange', { flag: 0 });
        // this.$emit('getFreight', 0);
      }
    },
    // 验证必填项，如果验证通过，返回info对象
    validate () {
      let error = '';
      if (parseInt(this.info.freight) !== 0 && this.info.freightPayType === null && !this.form.freightContract) {
        error = '请选择运费支付方式';
      }
      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            title: error
          });
          resolve(null);
        } else {
          resolve(this.info);
        }
      });
    },
    // 校验是否含有电池和计算运费差价接口
    async fecthFreightDifference () {
      this.loading = true;
      this.isHaveBattery = false;
      let params = {
        contractNum: this.contractNum,
        shippingType: this.info.shippingType,
        receiptAddressId: this.receiptAddressId,
        carrier: this.info.carrier
      };
      const res = await freightDifference(params);
      this.loading = false;
      const json = res.data;

      if (json.status === '200') {
        this.info.freight = json.data;
        if (Number(this.info.freight) > 0) {
          this.reChange();
        }
      } else if (json.status === '7100023') {
        // 包含电池状态码：7100023，不能选择航空
        this.isHaveBattery = true;
        this.info.shippingType = 0;
        // this.$notify.error({
        //   title: '包含电池不能选择航空'
        // });
      } else {
        this.info.freightPayType = 0;
        this.info.carrier = '默认物流';
        this.info.shippingType = 0;
      }
      this.$emit('getFreight', this.info.freight);
    }
  }
};
</script>

<style lang="scss" scoped>
.rj-page-card__content .item {
  display: inline-block;
}
.rj-page-card__content span {
  display: inline-block;
  margin-left: 40px;
}

.error-text{
  color: red;
}
</style>
